document.addEventListener('DOMContentLoaded', () => { // DOMContentLoaded contentReplaced
  'use strict'
  /*==================================
   SCROLLBAR
  ==================================*/
  // const isMobile = window.matchMedia('(max-width: 767px)').matches;
  // let myScrollbar = null; // Declare the Smooth Scrollbar variable

  // function addAOSAnimation() {
  //   const elements = document.querySelectorAll('[data-aos]');
  //   elements.forEach((el) => {
  //     el.classList.add('aos-animate');
  //   });
  // }

  // // Initialize AOS and add animations for all screens
  // AOS.init({
  //   disable: function () {
  //     const maxWidth = window.innerWidth;
  //     return maxWidth < 550;
  //   },
  // });
  // addAOSAnimation();

  // // Initialize Smooth Scrollbar only on web screens
  // if (!isMobile) {
  //   myScrollbar = Scrollbar.init(document.querySelector('[data-scroll-container]'));

  //   [].forEach.call(document.querySelectorAll('[data-aos]'), (el) => {
  //     myScrollbar.addListener(() => {
  //       if (myScrollbar.isVisible(el)) {
  //         el.classList.add('aos-animate');
  //       }
  //     });
  //   });
  // }


  /*==================================
   SCROLLBAR
  ==================================*/
  const isMobile = window.matchMedia('(max-width: 767px)').matches;

  function addAOSAnimation() {
    const elements = document.querySelectorAll('[data-aos]');
    elements.forEach((el) => {
      el.classList.add('aos-animate');
    });
  }

  AOS.init();
  addAOSAnimation();

  if (!isMobile) {
    const myScrollbar = Scrollbar.init(document.querySelector('[data-scroll-container]'));

    [].forEach.call(document.querySelectorAll('[data-aos]'), (el) => {
      myScrollbar.addListener(() => {
        if (myScrollbar.isVisible(el)) {
          el.classList.add('aos-animate');
        }
      });
    });
  }




  /*==================================
   OFFCANVAS
  ==================================*/
  const offcanvasElementList = document.querySelectorAll('.offcanvas')
  const offcanvasList = [...offcanvasElementList].map(offcanvasEl => new bootstrap.Offcanvas(offcanvasEl))

  const buttonMenu = document.querySelector('.uc-btn-menu-nav');
  buttonMenu.addEventListener('click', function () {
    buttonMenu.classList.toggle('open');
  });

  const myOffcanvas = document.getElementById('offcanvasMenu');
  myOffcanvas.addEventListener('hidden.bs.offcanvas', event => {
    buttonMenu.classList.remove('open');
  })

  var MenuOffcanvas = document.getElementById("offcanvasMenu");
  MenuOffcanvas.classList.add("none-offcanvasMenu");

  setTimeout(function () {
    MenuOffcanvas.classList.remove("none-offcanvasMenu");
  }, 500);

  /*==================================
   MOUSE FOLLOWER
  ==================================*/

  // MEDIA QUEIRY
  const mediaQuery = window.matchMedia('(min-width: 768px)');
  function handleTabletChange(e) {
    if (e.matches) {
      // CUSTOM CURSOR
      MouseFollower.registerGSAP(gsap);
      const cursor = new MouseFollower({
        container: document.body,
        speed: 0.55,
        skewingIcon: 0,
        stateDetection: {
          "-pointer": "button, label, a",
          "-hidden": ".form-control, .hidden-cursor, .scrollbar-thumb, .form-check, .custom-select",
        }
      });

    }
  }
  mediaQuery.addListener(handleTabletChange)
  handleTabletChange(mediaQuery)


  /*==================================
   RANDONLY
  ==================================*/
  // Select the elements to animate
  var items = document.querySelectorAll(".item-name");

  // Use GSAP's TimelineMax to animate the items
  var tl = new TimelineMax({ repeat: -1 });

  items.forEach(function (item, index) {
    // Randomly set the starting position of each item
    var randomX = Math.random() * 100 - 50;
    var randomY = Math.random() * 100 - 50;
    TweenMax.set(item, { x: randomX, y: randomY });

    // Animate the movement of each item
    tl.to(item, 2, { x: randomX * -1, y: randomY * -1, ease: Power2.easeInOut }, index * 0.05)
      .to(item, 2, { x: randomX, y: randomY, ease: Power2.easeInOut });
  });


  /*==================================
   PLAY VIDEO
  ==================================*/
  var video = document.querySelector('.video_mute');
  var gif = document.querySelector('.uc-gif-contat');
  var contactPlay = document.querySelector('.uc-item-contactplay');

  // Check if the browser is Safari
  var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

  if (isSafari) {
    // Safari does not support autoplay for video, so hide the video and show the GIF instead
    video.style.display = 'none';
    gif.style.display = 'block';
  } else {
    // Other browsers support autoplay for video, so hide the GIF and show the video instead
    gif.style.display = 'none';
    video.style.display = 'block';
  }

  // If the video fails to load or is not supported, show the GIF instead
  video.onerror = function () {
    video.style.display = 'none';
    gif.style.display = 'block';
  }

  // If the GIF fails to load, hide it
  gif.onerror = function () {
    gif.style.display = 'none';
  }

  // If neither the video nor the GIF can be displayed, hide the contactPlay
  if (video.style.display === 'none' && gif.style.display === 'none') {
    contactPlay.style.display = 'none';
  }


  /*==================================
   START THE PAGE LOADER
  ==================================*/
  let loader = document.querySelector(".uc-loading-page");
  loader.className += " hidden";

  // ANIMATION GSAP
  gsap.config({
    nullTargetWarn: false,
    trialWarn: false,
  });

  let tlU = gsap.timeline();
  tlU.from(
    ".text-animation span", 1.8,
    {
      y: 100,
      ease: "power4.out",
      delay: 0,
      skewY: 7,
      stagger: {
        amount: 0.4
      }
    })
    .fromTo(
      ".hero-animation span",
      {
        opacity: 0,
        delay: 0,
        duration: 1,
        transform: "translateY(150%) rotateX(-80deg)",
        transformOrigin: "center top",
        transformStyle: "preserve-3d",
        ease: "cubic-bezier(0.45,0.05,0.55,0.95)",
      },
      {
        opacity: 1,
        transform: "none",
        stagger: 0.1,
      },
      0
    )
    .to(
      ".delay-2", 1.8,
      {
        y: 0,
        delay: .5,
        duration: 1.5,
        opacity: 1,
        ease: "power4.out",
      },
      0
    )
    .to(
      ".delay-3", 1.8,
      {
        y: 0,
        delay: .8,
        duration: 1.5,
        opacity: 1,
        ease: "power4.out",
      },
      0
    )
    .to(
      ".delay-inside-2",
      {
        y: 0,
        delay: .2,
        duration: 1.5,
        opacity: 1,
        ease: "power4.out",
        stagger: 0.1,
      },
      0
    )
    .to(
      ".delay-inside-3",
      {
        y: 0,
        delay: .2,
        duration: 1.5,
        opacity: 1,
        ease: "power4.out",
        stagger: 0.1,
      },
      0
    )
    .to(
      ".delay-opacity", 1.8,
      {
        y: 0,
        delay: .3,
        duration: 1.5,
        opacity: 1,
        ease: "power4.out",
      },
      0
    )

  /*==================================
   RADIO BUTTONS
  ==================================*/
  const buttons = document.querySelectorAll('.uc-button-radio');
  buttons.forEach((button) => {
    button.addEventListener('click', () => {
      buttons.forEach((btn) => {
        btn.classList.remove('active');
      });
      button.classList.add('active');
    });
  });


  /*==================================
   VALIDATION
  ==================================*/
  // Check if the required elements exist on the page
  const nameInput = document.getElementById("input-1");
  const emailInput = document.getElementById("input-2");
  const phoneInput = document.getElementById("input-3");
  const BioInput = document.getElementById("input-5");
  const submitButton = document.querySelector(".uc-btn-more-blue");
  const feedbackText = document.querySelector(".uc-feedback-text");
  const radioButtons = document.querySelectorAll(".uc-buttons-options-radio button");

  if (nameInput && emailInput && phoneInput && BioInput && submitButton && feedbackText && radioButtons) {
    // Add event listeners for input validation
    nameInput.addEventListener("input", validateForm);
    BioInput.addEventListener("input", validateForm);
    emailInput.addEventListener("input", validateEmail);
    phoneInput.addEventListener("input", validateForm);

    // Add event listeners for radio button validation
    radioButtons.forEach(button => {
      button.addEventListener("click", validateForm);
    });

    function validateForm() {
      const nameValid = /^[a-zA-Z\s]+$/.test(nameInput.value);
      const BioValid = /^[a-zA-Z\s]+$/.test(BioInput.value);
      const emailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailInput.value);
      const phoneValid = !phoneInput.value || /^\d{10}$/.test(phoneInput.value);

      // Validate radio buttons
      const selectedBudgetButton = document.querySelector(".uc-buttons-options-radio button.active");
      const budgetValid = selectedBudgetButton !== null;

      // Enable or disable submit button
      submitButton.disabled = !(nameValid && emailValid && BioValid && budgetValid && phoneInput);
    }

    function validateEmail() {
      const emailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailInput.value);
      emailInput.classList.toggle("uc-error-msg", !emailValid);

      if (!emailValid) {
        feedbackText.textContent = "Invalid email format. Please provide a valid email address.";
        // You would typically send a verification email here using a server-side script or API.
      } else {
        feedbackText.textContent = ""; // Clear the error message if the email is valid.
      }

      // After validating the email, recheck the overall form validity
      validateForm();
    }
  }

  /*==================================
   SWIPER
  ==================================*/
  // Check if the elements with the specified classes exist on the page
  const slideLogos = document.querySelector('.slideLogos');
  const slideLogos02 = document.querySelector('.slideLogos02');

  if (slideLogos) {
    new Splide('.slideLogos', {
      type: 'loop',
      drag: false,
      focus: 'center',
      perPage: 4,
      autoScroll: {
        speed: 1.2,
        pauseOnHover: false,
        pauseOnFocus: false,
      },
    }).mount(window.splide.Extensions);
  }

  if (slideLogos02) {
    new Splide('.slideLogos02', {
      type: 'loop',
      drag: false,
      focus: 'center',
      perPage: 4,
      autoScroll: {
        speed: 1.2,
        pauseOnHover: false,
        pauseOnFocus: false,
      },
      direction: 'rtl',
    }).mount(window.splide.Extensions);
  }

  /*==================================
   ANIMATION MEEMOJI
  ==================================*/
  function addClassOnScroll() {
    const elements = document.querySelectorAll('.uc-block-users');

    elements.forEach(element => {
      if (window.innerWidth <= 768 && window.scrollY >= 80 && window.scrollY <= 500) {
        element.classList.add('active');
      } else {
        element.classList.remove('active');
      }
    });
  }

  // Attach the scroll event listener to the window
  window.addEventListener('scroll', addClassOnScroll);

  addClassOnScroll();


});
